module.exports = __webpack_public_path__ + "static/media/bd-med-infographic.b2e2ba57.png";